export enum PersonalOfferReason {
    RED_BUTTON = "RED_BUTTON",
    ZERO_DICE_ROLLS = "ZERO_DICE_ROLLS"
}